// EmailTemplates.js
// A simple file that exports your e-mail templates as an object.
// You can import { TEMPLATES } from './EmailTemplates.js' wherever needed.

export const TEMPLATES = {
    'Account Collections': {
      subject: 'Notice: Your Account Is Overdue',
      body: `Hello,
  
  Our records indicate that your account has an overdue balance.
  Please remit payment at your earliest convenience or contact us to
  set up a payment plan.
  
  Thank you,
  [Your Company]`
    },
  
    'Accounts - Miscellaneous': {
      subject: 'Miscellaneous Accounts Update',
      body: `Hello,
  
  We have some account-related updates for you. Please see the attached for more information.
  
  Thank you,
  [Your Company]`
    },
  
    'DOB - 3rd Party Signature Needed': {
      subject: '3rd Party Signature Required',
      body: `Hello,
  
  A third-party signature is required for the DOB filing. Please review and
  sign the attached document.
  
  Best regards,
  [Your Company]`
    },
  
    'DOB - Customer signature needed': {
      subject: 'Customer Signature Needed',
      body: `Hello,
  
  We require a customer signature for the DOB submission. Please sign and return at
  your earliest convenience.
  
  Thank you,
  [Your Company]`
    },
  
    'Inspection Approval': {
      subject: 'Inspection Approved',
      body: `Hello,
  
  Your recent inspection has been approved. Please see the attached approval
  letter for details.
  
  Thank you,
  [Your Company]`
    },
  
    'Inspection Filing': {
      subject: 'Inspection Filing',
      body: `Hello,
  
  We have filed the inspection on your behalf. Attached is the filing confirmation and
  relevant documentation.
  
  Best,
  [Your Company]`
    },
  
    'Inspection Filing Corrections': {
      subject: 'Inspection Filing Corrections Required',
      body: `Hello,
  
  We have received feedback indicating that corrections are needed for your inspection filing.
  Please see the attached details and let us know if you have any questions.
  
  Regards,
  [Your Company]`
    },
  
    'Inspection Invoice': {
      subject: 'Inspection Invoice',
      body: `Hello,
  
  Attached is the invoice for the recent inspection services. Please remit payment at
  your earliest convenience.
  
  Thank you,
  [Your Company]`
    },
  
    'Inspection Notification Letter': {
      subject: 'Inspection Notification',
      body: `Hello,
  
  This is to inform you that an inspection is scheduled / has been completed (depending on context).
  Please see attached notification for details.
  
  Thank you,
  [Your Company]`
    },
  
    'Inspection Repair Proposal': {
      subject: 'Repair Proposal for Inspection',
      body: `Hello,
  
  Based on our inspection findings, we have prepared a repair proposal.
  Please review the attached document for details and cost estimates.
  
  Thank you,
  [Your Company]`
    },
  
    'Inspection Results': {
      subject: 'Inspection Results',
      body: `Hello,
  
  Please find attached the results of the recent inspection. If you have any questions,
  feel free to contact us.
  
  Thanks,
  [Your Company]`
    },
  
    'Inspection Scheduled': {
      subject: 'Inspection Scheduled',
      body: `Hello,
  
  We have scheduled an inspection for your property. The attached document includes
  the date, time, and other details.
  
  Thank you,
  [Your Company]`
    },
  
    'Inspections to Schedule': {
      subject: 'Inspections to be Scheduled',
      body: `Hello,
  
  We still need to schedule inspections for your property. Please review the attached
  information and reply with your availability.
  
  Regards,
  [Your Company]`
    },
  
    'Miscellaneous Email': {
      subject: 'Miscellaneous Information',
      body: `Hello,
  
  Here is some miscellaneous information related to your account or inspection. If you have questions,
  please let us know.
  
  Best,
  [Your Company]`
    },
  
    'Proposal Document': {
      subject: 'Proposal Document',
      body: `Hello,
  
  Attached is our proposal document. Please review and let us know if you have any questions or concerns.
  
  Thank you,
  [Your Company]`
    }
  };
  